import { render, staticRenderFns } from "./ArticleInput.vue?vue&type=template&id=277d84cc"
import script from "./ArticleInput.vue?vue&type=script&lang=js"
export * from "./ArticleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports